import { HonestSelectInput } from 'components/HonestSelect/HonestSelectInput'
import { useState } from 'react'
import { Box, Flex } from 'styling/GlobalStyles'
import { BedContainer, BedFooter, BedMiddleSection, BlockContainer, BlockStatusesContainer, CampContainer, CampOverviewContainer, ColoredSquare } from '../Accommodation.style'
import { BodyText, Head2, OtherText, TitleText } from 'styling/Typography'
import Chevron from 'assets/icons/Chevron'
import { ThreeDots } from 'assets/icons/ThreeDots'
import { PersonIcon } from '../icons/PersonIcon'

export const BadManagement = () => {


    const BlockSection = () => {
        const [active, setActive] = useState(false)
        return <CampContainer active={active} onClick={() => setActive(!active)} >
            <CampOverviewContainer>
                <Flex column between height='100%'>
                    <BodyText style={{ fontSize: 20 }} >North Camp</BodyText>
                    <BodyText grey >4 rooms · 12 beds total</BodyText>
                </Flex>
                <Flex height='100%' gap='1rem' center >
                    <Chevron open={active} />
                </Flex>
            </CampOverviewContainer>
            <BlockStatusesContainer style={{ padding: '1rem' }} fr='3' >
                <Bed />
                <Bed />
                <Bed />
                <Bed />
            </BlockStatusesContainer>
        </CampContainer>
    }

    const Bed = () => {
        return <BedContainer onClick={(e) => e.stopPropagation()} >
            <Flex gap='0.5rem' width='100%' between>
                <Flex gap='0.5rem' >
                    <ColoredSquare style={{ height: 40, width: 40 }} color={colors.available} />
                    <Flex column between >
                        <TitleText>Bed 1</TitleText>
                        <BodyText color={colors.occupied} >OCCUPIED</BodyText>
                    </Flex>
                </Flex>
                <ThreeDots />
            </Flex>

            <BedMiddleSection borderColor={colors.occupied} >
                <Flex gap='0.5rem' >
                    <PersonIcon />
                    <OtherText color={colors.occupied} >CURRENT GUEST</OtherText>
                </Flex>
                <BodyText style={{ margin: '0.5rem 0' }} >John Smith</BodyText>
                <Flex column gap='3px' >
                    <OtherText grey >ID: EMP-001</OtherText>
                    <OtherText grey>Check-in: Feb 01, 2028</OtherText>
                    <OtherText grey >Expected checkout: Feb 08, 2028</OtherText>
                </Flex>
            </BedMiddleSection>

            <BedFooter>
                <OtherText  >BED POLICIES</OtherText>
                <Flex width='100%' between ><OtherText grey >Genter:</OtherText><BodyText weight='bold' >MALE</BodyText></Flex>
                <Flex width='100%' between ><OtherText grey >Tier:</OtherText><BodyText weight='bold' >STANDARD</BodyText></Flex>
            </BedFooter>

        </BedContainer>
    }

    return <>
        <Box width='100%' height='105px' style={{ padding: '1rem', borderTop: '1px solid #ff9900', borderRadius: '0.5rem' }} >
            <HonestSelectInput name='camp' labelText='Select Camp' options={[]} onChange={null} width='335px' />
            {/* ASYNC */}
        </Box>
        <Flex column gap='1rem' mt='16' >
            <BlockSection />
            <BlockSection />
            <BlockSection />
            <BlockSection />
        </Flex>
    </>
}



const colors = {
    totalCapacity: '#ff9800',
    available: '#10B981',
    occupied: '#51A2FF',
    dirty: '#F4D03F',
    blocked: '#FF6467',
}